module.exports = __webpack_public_path__ + "static/media/x.3dfd8efa.svg";